import classNames from 'classnames';
import { FC } from 'react';

import style from './Separator.module.scss';

interface SeparatorTypes {
  classes?: string;
}

export const Separator: FC<SeparatorTypes> = ({ classes }) => (
  <div className={classNames(style.separator, classes)}></div>
);
